<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>

import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "313px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      // console.log("统计数据", data);
      let _this = this;
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
      this.chart = echarts.init(this.$el, "macarons");
      let chartStyle = {
        grid: {
          left: "5%",
          right: "2%",
          bottom: 50,
        },
        legend: {
          textStyle: {
            color: "#409EFF",
          },
          top: "2%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: 'rgba(255,255,255,0.5)'
        },
        xAxis: {
          type: "category",
          data: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
          splitArea: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [],
      }
      chartStyle.series = [];
      for (var key in data) {
        let seriesStyle = {
          name: "",
          data: [],
          type: "bar",
          barMaxWidth: 12,
          stack: "one",
        }
        seriesStyle.name = data[key].name
        seriesStyle.data = data[key].data
        chartStyle.series.push(seriesStyle);
      }
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(chartStyle);
    },

  },
};
</script>
